export default __webpack_public_path__ + "static/footer_logo_companion-a6a0a8e3-df16078e4c9c12960177e17a456c5d6a.png";